module.exports = __webpack_public_path__ + "static/media/announcement-title.05916b83.svg";